import { defineComponent as _defineComponent } from 'vue'
import OnboardingStep from '@/modules/onboarding/OnboardingStep.vue';
import {TourName} from '@/modules/onboarding/tour/models/TourOptions';
import {TourStep} from '@/modules/onboarding/tour/models/TourStep';
import {onKeyStroke} from '@vueuse/core';
import {computed, getCurrentInstance, onMounted} from 'vue';
import {Tour} from '@/modules/onboarding/tour/Tour';


export default /*#__PURE__*/_defineComponent({
  __name: 'OnboardingContainer',
  props: {
    tourName: null,
    steps: null,
    standalone: { type: Boolean, default: false }
  },
  emits: ['dismiss'],
  setup(__props: any) {

const props = __props as { tourName: TourName, steps: TourStep[], standalone: boolean };





const OPTIONS = {
  // disable the default keyboard navigation
  useKeyboardNavigation: false,
};

const instance = getCurrentInstance();
const onboarding = computed<Tour>(() => instance!.proxy.$onboarding.tours[props.tourName]);

onKeyStroke('ArrowLeft', () => {
  if (!props.standalone) {
    onboarding.value?.previousStep();
  }
});

onKeyStroke('ArrowRight', () => {
  if (!props.standalone) {
    onboarding.value?.nextStep();
  }
});

onMounted(() => {
  // In standalone mode there is no external driver (no START modal / Tour.goToStep), so start the
  // single-step bubble ourselves. The child <v-tour> has registered into $tours by now.
  if (props.standalone) {
    instance!.proxy.$tours?.[props.tourName]?.start();
  }
});

return { __sfc: true,props, OPTIONS, instance, onboarding, OnboardingStep }
}

})